'use strict';

// shimované pluginy většinou nemají export, většinou extendují jQuery object
// const TargetBlankAutoTitle = require('fg-frontend/plugins/required/targetBlankAutoTitle');
require('./web/jquery.externalLinks');
const Preloader = require('fg-frontend/plugins/universal-preloader/preloader');
const isMobile = require('ismobilejs');
require('fg-frontend/plugins/jquery.universal-pagination');
require('picturefill');
require('./web/highslide-settings');
require('./web/svg4everybody');
// require('./web/jquery.googlemap');
require('./web/jquery.gm');
require('./web/jquery.gm.conf');
require('./web/jquery.formSlider');
require('./web/jquery.formControlPattern');
require('./web/jquery.formControlIndent');
require('./web/jquery.ui.touch.punch');
require('./web/jquery.toggleBox');
require('./web/jquery.fulltextSearch');
// require('./web/jquery.tlsNotification');

require('jquery-ui/ui/widgets/datepicker');
require('jquery-ui/ui/i18n/datepicker-cs');

// require('./web/typeahead.bundle');
// const Bloodhound = require('./web/bloodhound');
// import './web/Typeahead';

// require('selectize');
// require('dropkickjs');
// require('select2');

// require('bootstrap/collapse');
// require('bootstrap/tooltip');
require('protip');

require('./plUpload/fg.upload');
require('inputmask/dist/inputmask/inputmask');
require('inputmask/dist/inputmask/inputmask.extensions');
// require('inputmask/dist/inputmask/inputmask.numeric.extensions');
// require('inputmask/dist/inputmask/inputmask.date.extensions');
// require('inputmask/dist/inputmask/inputmask.phone.extensions');
require('inputmask/dist/inputmask/jquery.inputmask');

require('./web/jquery.fgAnalytics');
require('./web/jquery.affiliate');
require('./web/jquery.appear');

projectConfig.googlemaps = window.projectConfig.googlemaps || {};

const $b = $('body');
const $w = $(window);

/* nastaveni vystreleni custom event
 * --------------------------------*/
// universal preloader
const universalPreloader = new Preloader();
// todo phr overit s PM, kdy se ma zobrazit preloader
if ( document.querySelectorAll('.js_gtmFlexiAbt').length ) {
	$(document).trigger('FG_UNIVERSAL_PRELOADER_START', 'MODAL_ABT');
	$(window).on('load', e => $(document).trigger('FG_UNIVERSAL_PRELOADER_STOP', 'MODAL_ABT'));
}

/**
 * Pokud máte na stránce anchor s target="blank" atributem, který nemá vyplněný title, nasadí se na něj
 * automaticky titulek ve smyslu "Otevře se v novém okně" dle langu stránky (atribut html lang).
 * Texty jsou definované ve třídě TargetBlankAutoTitle. Lze je definovat ručně při incicalizaci
 * např:  $("body").targetBlankAutoTitle({labels: {cs: "Lorem ipsum", sk: "Dolor sit"}});
 *
 * Pro weby mimo standardní kolekci jazyků (en, de, sk, cz) doporučuji překlad korekturovat.
 * Byl pouze automaticky přeložen.
 *
 * Korekturované překlady můžete dávat do issue https://ep.fg.cz/issues/60227
 *
 * Zkratky jazyků jsou z ISO 639-1 normy
 */
// window.targetBlankAutoTitle = new TargetBlankAutoTitle();

/**
 * Formats number with leading '0' to given {stringLength}
 * {1}.leftZeroPad(4) => 0001
 * {12345}.leftZeroPad(4) => 12345
 * {6.6}.leftZeroPad(4) => 0006.6
 * @param stringLength
 */
Number.prototype.leftZeroPad = function (stringLength) {
	const n = Math.abs(this);
	const zeros = Math.max(0, stringLength - Math.floor(n).toString().length);
	let zeroString = Math.pow(10, zeros).toString().substr(1);
	if ( this < 0 ) {
		zeroString = `-${ zeroString }`;
	}

	return zeroString + n.toString();
};

/**
 * Number.prototype.format(n, x, s, c)
 *
 * @see https://stackoverflow.com/a/14428340
 * @demo https://jsfiddle.net/hAfMM/612/
 * @param n: (Integer) length of decimal part (default: 0)
 * @param x: (Integer) length of group part (default: 3)
 * @param s: (Mixed) sections delimiter (default: ' ')
 * @param c: (Mixed) decimal delimiter (default: ',')
 */
Number.prototype.indentNumber = function (n, x, s, c) {
	const re = `\\d(?=(\\d{${  x || 3  }})+${  n > 0 ? '\\D' : '$'  })`;
	const num = this.toFixed(Math.max(0, ~~n));
	return (c ? num.replace(',', c) : num).replace(new RegExp(re, 'g'), `$&${ s || ' ' }`);
};


/**
 * JS oznámení o použití cookies na webu
 * default nastavení - viz: fg-frontend/plugins/required/jquery.cookies-policy
 *
 * * možnost redefinovat si styly přidáním parametru přes parametr css, případně je barvu tlačítka a odkazu: css.brandColor
 * * position - určuje vložení do požadovaného elementu na začátek (position: 'top') nebo na konec (position: 'bottom'),
 * * možnost definovat si vlastní textaci přes parametr messages.lang: (defaulty jsou v CS, SK, EN, DE, RU, ES)
 */

/* NAHRAZENO COOKIEBOTEM */

// formularovy slider
$('.js_form-slider').formSlider();
$('.monthly_premium_js_form-slider').formSlider({
	type: 'monthly-premium',
});
$('.net_monthly_income_js_form-slider').formSlider({
	type: 'net-monthly-income',
});
$('.monthly_instalment_js_form-slider').formSlider({
	type: 'monthly-instalment',
});
$('.rate_js_form-slider').formSlider({
	type: 'rate',
});
$(document).on('ajaxComplete', (e) => {
	$('.js_form-slider').formSlider();
	$('.monthly_premium_js_form-slider').formSlider({
		type: 'monthly-premium',
	});
	$('.net_monthly_income_js_form-slider').formSlider({
		type: 'net-monthly-income',
	});
	$('.monthly_instalment_js_form-slider').formSlider({
		type: 'monthly-instalment',
	});
	$('.rate_js_form-slider').formSlider({
		type: 'rate',
	});
});

// inicializace ToggleBoxu / rozklikavatka
$('.js_toggler').toggleBox();

// todo move to component
$('.js_calculator-flexi-risk a.js_scroll').on('click', function(){
	const target = $(this).attr('href');
	$(target).show();
});

/* google map */
$.googlemap.setDefaults({
	mapOptions:             {
		scrollwheel: false,
		// simple map desing
		/*
		styles: [
			{ 'featureType': 'landscape', 'stylers': [ { 'visibility': 'off' } ] },
			{ 'featureType': 'poi', 'stylers': [ { 'visibility': 'off' } ] },
			{ 'featureType': 'administrative.province', 'stylers': [ { 'visibility': 'off' } ] },
			{ 'featureType': 'administrative.land_parcel', 'stylers': [ { 'visibility': 'off' } ] },
			{ 'featureType': 'administrative.neighborhood', 'stylers': [ { 'visibility': 'off' } ] },
			{ 'featureType': 'road.local', 'stylers': [ { 'visibility': 'off' } ] },
			{ 'featureType': 'road.arterial', 'stylers': [ { 'visibility': 'simplified' } ] },
			{ 'featureType': 'water', 'stylers': [ { 'visibility': 'on' }, { 'hue': '#00ccff' }, { 'saturation': -83 }, { 'lightness': -15 } ] },
			{ 'featureType': 'road', 'elementType': 'labels', 'stylers': [ { 'visibility': 'off' } ] },
			{ 'featureType': 'transit', 'stylers': [ { 'visibility': 'off' } ] },
			{ 'featureType': 'administrative.locality', 'elementType': 'labels.text.stroke', 'stylers': [ { 'visibility': 'off' } ] },
			{ 'featureType': 'road.highway', 'elementType': 'geometry.stroke', 'stylers': [ { 'visibility': 'off' } ] },
			{ 'featureType': 'road.highway', 'elementType': 'geometry.fill', 'stylers': [ { 'lightness': 100 }, { 'weight': 2.9 } ] },
			{ 'featureType': 'road.local', 'stylers': [ { 'visibility': 'on' } ] },
			{ 'featureType': 'administrative.locality' },
		],
		*/
	},
	markerTypes:            [
		{},
		{
			icon: {
				url: '/img/google-map/koop-marker-01.png',
				size: new google.maps.Size(48, 64),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(24, 64),
			},
			shape: {
				coords: [0, 0, 48, 64],
				type:   'rect',
			},
		}, {
			icon: {
				url: '/img/google-map/koop-marker-02.png',
				size: new google.maps.Size(48, 64),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(24, 64),
			},
			shape: {
				coords: [0, 0, 48, 64],
				type:   'rect',
			},
		},
	],
	bubbleContentFormatter: (mData) => {
		let str = '';
		if (mData.title) {
			str += `<p class="h3 title">${ mData.title }</p>`;
		}
		if (mData.bubbleContent) {
			str += mData.bubbleContent;
		}
		return str;

	},
});

/**
 * vyhledanim mista u mapy pobocek aktivuje google mapu
 */
$(document).one('submit.gMapActivationSearch', '.gmapBranchesForm', (e) => {
	e.preventDefault();
	const inactiveMap = $('.google-map__inactive');
	if ( inactiveMap.length ) {
		inactiveMap.click();
		setTimeout(() => {
			$('.gmapBranchesForm').submit();
			$(document).off('.gMapActivationSearch');
		}, 1500);
	}
});

/**
 * lazy loading placeholderu nad mapou
 */
$('.gmapBranchesForm').appear();
$(document).one('appear', '.gmapBranchesForm', (e) => {
	$('.google-map__inactive').addClass('inView');
});

if (isMobile.apple.device) {
	$b.addClass('ios');
}

if ( /(msie|trident)/gi.test( window.navigator.userAgent) ) {
	$('html').addClass('ie');
}

/* menu pro mobilní zařízení */
const controlMenu = () => {
	// const animateDuration = 800;
	let visitedMenu = false;

	const cloneMenu = () => {
		$('#page-header').before('<div class="navigation-active" id="js_navigation-active">');
		$('.js_menuBurger').clone().appendTo('#js_navigation-active').addClass('menu-burger-active close');
		$('.main-menu').clone().appendTo('#js_navigation-active');
		$('.search').clone().appendTo('#js_navigation-active');
		$('#js_navigation-active').append('<div class="contact-bar"></div>');
		$('.contact-bar .button-links').clone().appendTo('#js_navigation-active .contact-bar');
	};

	const destroyMenu = () => {
		$('#js_navigation-active').remove();
	};

	const toggleMenu = () => {
		if (visitedMenu === false) {
			$b.toggleClass('rwd-navigation-active');
			cloneMenu();
			visitedMenu = true;
		} else {
			destroyMenu();
			$b.toggleClass('rwd-navigation-active');
			visitedMenu = false;
		}
	};

	const init = () => {
		$b.on('click', '.js_menuBurger', (e) => {
			toggleMenu();
			e.preventDefault();
		});
	};

	init();
};
controlMenu();

// Odscrollování na kotvu
window.scrollToAnchor = (element) => {
	let targetOffset = 0;
	if ( $(element).length ) {
		if ($('#sticky-bar').height() > 0) {
			targetOffset = parseInt($(element).offset().top - ($('#sticky-bar').outerHeight() + 40));
		} else {
			targetOffset = parseInt($(element).offset().top);
		}
		$('html,body').animate({ scrollTop: targetOffset }, 800);
	}
};

/*
 * INIT FUNCTIONS
 */
$w.on('load', () => {
	/* svg */
	svg4everybody();

	initDatepicker();

	validateInputsOnPageEnter();

	rememberFormId();

	initInfobar();

	if ($('.panel-group').length && window.location.hash.length) {
		$(window.location.hash).siblings().find('.panel-control').click();
	}

	const $cid = $('.js_cid-tracker');
	if ( $cid.length ) {
		const storeCid = (cid, fromTimeout = false) => {
			if (cid === 'false' || cid === '')
				cid = 'neznámé';
			$cid.val(cid);
			// console.log(`cid = ${cid}${fromTimeout?" - from timeout":""}`);
		};
		if ( window.projectConfig.cidTracker ) {
			storeCid(window.projectConfig.cidTracker || '');
		} else {
			window.setTimeout(() => storeCid(window.projectConfig.cidTracker || '', true), 800);
		}
	}

	const wlh = window.location.hash;
	if (/#tab-\d+/i.test(wlh)) {
		$('.transformer-tabs-ms').find(`a[href="${ wlh }"]`).click();
	}

	$('.form-control').trigger('checkval');

	const downloadableItem = $('.list-files.js_downloadAttachments li a');  // get links
	const downloadAllAttBtn = $('.js_downloadAttachmentsBtn');              // get button
	const downloadableLinks = [];                                           // set empty array for href values

	// push values into array
	downloadableItem.each( (i, element) => {
		downloadableLinks.push($(element).attr('href'));
	});

	// download action through iframe methods
	const download = () => {
		// IE11 doesn't like iframes
		if ( $b.hasClass('ie') ) {
			downloadableItem.each( (item) => {
				$(item).click();
			});
		} else {
			for ( let i = 0; i < downloadableLinks.length; i++ ) {
				const iframe = $('<iframe style="visibility: collapse;"></iframe>');
				$b.append(iframe);
				const content = iframe[ 0 ].contentDocument;
				const form = `<form action="${ downloadableLinks[ i ] }" method="GET"><submit /></form>`;
				content.write(form);
				$('form', content).submit();
				setTimeout( ( iframe => () => iframe.remove() )(iframe), 2000);
			}
		}
	};

	// click to download all
	downloadAllAttBtn.on('click', () => {
		download();
	});

});

$(document).on('afterContentsReplaced', function () {

	initDatepicker();

	initInfobar();

	$('.form-control').trigger('checkval');

	if (validationPassed) {
		$(this).find('.js_disabled').removeClass('disabled');
		$(this).find('.js_bubble').hide();
	} else if(validationPassed != undefined) {
		$(this).find('.js_disabled').addClass('disabled');
		$(this).find('.js_bubble').show();
	}

	$('.js_inputmask').inputmask();

	$('.js_toggler').toggleBox();

	// schova .protip bubliny po PU
	// $('button.protip[type="submit"]').protipHide(); // nefunguje
	$('body > .protip-container.protip-show').removeClass('protip-show');
});

// animace scrollu na hash
document.addEventListener('click', (e) => {
	if ( e.target && e.target.classList && e.target.classList.contains('js_scroll') ) {

		// v pripade kliku na tlacitko mirici na zalozku, proved klik na danou zolozku (pokud existuje)
		if ( document.querySelectorAll(`.tabs a[href$="${ e.target.hash }"]`).length ) {
			document.querySelector(`.tabs a[href$="${ e.target.hash }"]`).dispatchEvent(new Event('click'));
		}
		scrollToAnchor( e.target.hash );
		e.preventDefault();
	}
});

$.externalLinks({
	addIcon:  false,
	iconArea: '.main',
	// iconClass: 'out',
	// removeIcon: '.photogallery, .files',
});

const $pt = $('.protip');
if ( $pt.length ) {
	$pt.removeAttr('title');
	$.protip({
		defaults: {
			trigger: 'click',
			gravity: 'top 0 -8; left',
		},
	});
}

/* fulltext */
$('#js_search-anchor').on('click', () => {
	$('#js_search-form').toggleClass('search-form-active');
	$('#fulltext-query').focus();
});
$('#js_search-close').on('click', () => {
	$('#js_search-form').toggleClass('search-form-active');
});
$('.search-form').fulltextSearch();


/**
 * Fotogalerie
 */
$('.js_lightgallery').each( () => {
	const animationSpeed = 300;
	const $gallery = $(this).find('.thumbs');
	const $previous = $(this).find('.control-previous');
	const $next = $(this).find('.control-next');

	$previous.click( () => {
		$gallery.fadeOut(animationSpeed, () => {
			$gallery.find('.related-gallery-thumbnail:last').prependTo($gallery);
			$gallery.fadeIn(animationSpeed);
		});
	});
	$next.click( () => {
		$gallery.fadeOut(animationSpeed, () => {
			$gallery.find('.related-gallery-thumbnail:first').appendTo($gallery);
			$gallery.fadeIn(animationSpeed);
		});
	});
});

$('.js_submenu-control').on('click', function () {
	$(this).toggleClass('submenu-opened');
	$('#submenu').toggle();
});

$('.js_tabs-link').on('click', function () {
	const anchor = $(this).data('href');
	$('.tabs-item').removeClass('tabs-item-active');
	$(this).parent().addClass('tabs-item-active');
	$('.calculator-wrapper').removeClass('active-calculator');
	$(`#${ anchor }`).addClass('active-calculator');
});

// Stránkování
$('.js_pagination-static').universalPagination({
	lang: window.projectConfig.lang || 'en',

	// getter settings
	nextPageButtonSelector: '.js_pagination-next',
	listSelector:           '.js_articleListing',
	itemSelector:           '.media',
	paginationSelector:     '.js_pagination-static',

	// render settings
	wrapperClass:     'pagination-wrapper',
	nextClass:        'btn noPartialUpdate',
	nextWrapperClass: 'pagination-next buttons'
});

$('.panel-collapse').on('show.bs.collapse', function () {
	$(this).siblings('.panel-heading').addClass('active');
});

$('.panel-collapse').on('hide.bs.collapse', function () {
	$(this).siblings('.panel-heading').removeClass('active');
});

$.fn.toggleText = function (dataId) {
	const newText = $(this).data(dataId);
	$(this).data(dataId, $(this).text());
	$(this).text(newText);
};

/**
 *  Transformer tabs
 */
function tabControl() {
	const tabs = $('.transformer-tabs .tabs');

	tabs.find('a').on('click', function (event) {
		event.preventDefault();
		const target = $(this).attr('href');
		const text = $(this).text().trim();
		const tabs = $(this).parents('.tabs');
		const buttons = tabs.find('a');
		const item = tabs.parents('.transformer-tabs').find('.item');
		buttons.removeClass('active');
		item.removeClass('active');
		tabs.find('li').removeClass('tabs-item-active');
		$(this).toggleClass('active');
		$(target).toggleClass('active').trigger('resizeEnd').trigger('show.formSlider'); // pokud zalozka obsahuje slider, je nutne jej prekreslit
		$(this).parents('li').toggleClass('tabs-item-active');
		$('.item').unbind('click');
	});

	$('.transformer-tabs .trigger').on('click', function () {
		const container = $(this).parents('.transformer-tabs');
		const currId = $(this).parents('.item').attr('id');

		$(this).parents('.item').toggleClass('active').siblings().removeClass('active');
		$(this).parents('.item').trigger('resizeEnd').trigger('show.formSlider'); // pokud zalozka obsahuje slider, je nutne jej prekreslit
		container.find('.tabs a, .tabs a.active').removeClass('active');
		container.find('li.tabs-item-active').removeClass('tabs-item-active');
		container.find(`.tabs a[href$="#${ currId }"]`).addClass('active');
		container.find(`.tabs a[href$="#${ currId }"]`).parent('li').addClass('tabs-item-active');
		$('html,body').animate({ scrollTop: $(this).offset().top }, 200);
		return false;
	});

}
tabControl();

/* If we close accordion on small screens, trigger item on large screens */
$w.on('resize', () => {
	if ($('.transformer-tabs .tabs').is(':visible') && $('.item').hasClass('active') === false) {
		$('.transformer-tabs .tabs').find('a.active').click();
	}
});

$('.list-package .trigger').on('click', function () {
	$(this).parents('.package').toggleClass('active').siblings().removeClass('active');
});
if (isMobile.phone) {
	$('.list-package .package:eq(0) .trigger').trigger('click');
}

$('.js_show-summary').on('click', (e) => {
	e.preventDefault();
	$('.summary').toggleClass('active');
	$(this).toggleText('toggle-text');
});

const initInfobar = () => {
	const infobar1 = document.getElementById('js_infobar-1');
	const infobar2 = document.getElementById('js_infobar-2');
	if (infobar1 || infobar2) {
		const now = new Date();
		let time = now.getTime();
		// 24 - hours, 360000 - miliseconds
		time += 24 * 3600000;
		now.setTime(time);
		if (infobar1) {
			const buttonClose1 = document.getElementById('js_infobar-1-button-close');
			if (document.cookie.indexOf('cookieInfobar1Visited') >= 0) {
				infobar1.classList.add('infobar--deactive');
			} else {
				buttonClose1.addEventListener('click', () => {
					infobar1.classList.add('infobar--deactive');
					document.cookie = 'cookieInfobar1Visited=true; expires=' + now.toGMTString() + '; path=/';
				});
			}
		}
		if (infobar2) {
			const buttonClose2 = document.getElementById('js_infobar-2-button-close');
			if (document.cookie.indexOf('cookieInfobar2Visited') >= 0) {
				infobar2.classList.add('infobar--deactive');
			} else {
				buttonClose2.addEventListener('click', () => {
					infobar2.classList.add('infobar--deactive');
					document.cookie = 'cookieInfobar2Visited=true; expires=' + now.toGMTString() + '; path=/';
				});
			}
		}
	}
};

const initDatepicker = () => {

	// kontrola podpory input[@type=date]
	const testElem = document.createElement('input');
	testElem.setAttribute('type', 'date');
	const dateElm = $('.js_datepicker');
	// console.log('init datepicker');
	if ( ( !isMobile.phone && !isMobile.tabconst ) || testElem.getAttribute('type') !== 'date') {
		// date neni podporovano, nebo jsem na desktopu => fallback na jQueryUI
		// console.log('fallback to jQueryUI');
		dateElm.each(function () {
			const $dp = $(this);
			$dp
				.prop('type','text') // zabrani na kolizi nativniho datepickeru a jQueryUI
				.addClass('noLiveValidation') // hotfix: liveValidace se chytne driv, nez plugin vyplni pole, e.a. vzdy vraci chybu
				.datepicker({
					changeMonth: true,
					changeYear:  true,
					yearRange:   $dp.data('yearRange') || 'c-150:c+150',
					minDate:     new Date($dp.data('minDate')),
					maxDate:     new Date($dp.data('maxDate')),
					dateFormat:  $dp.data('dateFormat') || 'd. m. yy',
					onSelect:    () => {
						storeDateAsData($dp, $dp.datepicker('getDate'), 'restDate');
						$dp
							.removeClass('noLiveValidation') // hotfix: liveValidace se chytne driv, nez plugin vyplni pole, e.a. vzdy vraci chybu
							.delay(100).trigger('blur').trigger('change')
						;
					}
				})
				.on('change', function () {
					reformatDateInputValue($(this));
					storeDateAsData($(this), $(this).datepicker('getDate'), 'restDate');
				})
				.on('blur', function () {
					$(this).trigger('requestValidation');
					reformatDateInputValue($(this));
				})
			;
		});
	}
	else {
		// console.log('using native datepicker');
		dateElm
			.each(function () {
				$(this).prop('type', 'date');
				if ( $(this).data('min') ) {
					$(this).prop('min', $(this).data('min') );
				}
				if ( $(this).data('max') ) {
					$(this).prop('max', $(this).data('max') );
				}
				if ( $(this).data('step') ) {
					$(this).prop('step', $(this).data('step') );
				}
			})
			.on('change', function () {
				$(this).val() !== '' ?
					$(this).addClass('has-value') :
					$(this).removeClass('has-value');
				// reformatDateInputValue($(this)); // hodnota datumu je ve formatu yyyy-mm-dd , neni potreba preformatovat
				storeDateAsData($(this), (new Date( $(this).val() )), 'restDate');
				$(this).trigger('requestValidation');
			});
	}

};

/**
 * Stores {dateObj} in {$element} in given {datesetName}
 * Reformats date to yyyy-MM-dd pattern
 *
 * @param $element jQuery element
 * @param dateObj Parsable date
 * @param datasetName Name of data attribute
 */
const storeDateAsData = ($element, dateObj, datasetName) => {
	if ( dateObj instanceof Date ) {
		const formattedDate = `${ (dateObj.getFullYear()).leftZeroPad(4) }-${ (dateObj.getMonth() + 1).leftZeroPad(2) }-${ (dateObj.getDate()).leftZeroPad(2) }`;
		$element.data(datasetName, formattedDate);
		// console.log(`DATA: ${formattedDate}`);
	}
};

const reformatDateInputValue = function ($element) {
	let dateObj = new Date();
	const elmVal = `${ $element.val() }`;
	if (elmVal === '') {
		$element.val('');
		return;
	}
	if (/\d{1,2}\.\s*\d{1,2}\.\s*\d{4}/.test(elmVal) ) {
		const parts = elmVal.split(/[. ] */);
		if (typeof parseInt(parts[0]) === 'number' && typeof parseInt(parts[1]) === 'number' && typeof parseInt(parts[2]) === 'number') {
			dateObj = new Date(parts[2], parts[1] - 1, parts[0]);
		}
	}
	const formattedDate = `${ dateObj.getDate() }. ${ dateObj.getMonth() + 1  }. ${ dateObj.getFullYear() }`;
	$element.val( formattedDate );
	// console.log( `REFORMATTED: ${formattedDate}` );
};

$(document).on('click', '.js_submit', function (e) {
	const $form = $(this).parents('form');
	if ($form.length) {
		const submitEvent = $(this).data('submitEvent');
		const submitTarget = $(this).data('submitTarget');
		$form.find(submitTarget).on(submitEvent, () => {
			$form.delay(50).find('#submit').click();
		});
	}
});

// todo webaction
function validateInputsOnPageEnter() {
	$('.form-control.js_validate').each(function () {
		const $t = $(this);
		if ( $t.val() !== '' ) {
			$t.trigger('change').trigger('blur').trigger('requestValidation');
		}
	});
	// $('[type="radio"]:checked,[type="checkbox"]:checked').trigger('requestValidation');
}

// todo webaction
/**
 * Propise formId do URL.
 *
 * @see https://mm.fg.cz/forrest/pl/k6tcrngf3pd7zyu7ji9fk8aidh
 */
function rememberFormId() {
	if ( $b.hasClass('js_rememberFormId') && !getUrlParameter('formId') && $('.js_rememberFormId_target').length ) {
		const formId = $('[name="formId"]','.js_rememberFormId_target').val();
		let params = window.location.search;
		params += window.location.search.match(/^\?/i) ? '&' : '?';
		params += `formId=${ formId }${ window.location.hash || ''}`;
		window.history.replaceState({},'', window.location.pathname + params);
	}
}

/* If there are links in wisiwyg container, or in promo container with href what matches the anchors in tabs - trigger click */
$('.transformer-tabs .wysiwyg a[href^="#"], .transformer-tabs .promo a[href^="#"]').on('click', function (e) {
	e.preventDefault();
	const linkInTabNavig = $(`.tabs a[href$="${  $(this).attr('href')  }"]`);
	if ( linkInTabNavig.length ) {
		linkInTabNavig.click();
		scrollToAnchor($(this).attr('href'));
	}
});

// todo notused - remove
/* otevření Highslidu z odkazů */
$('.js_openHS').on('click', function (e) {
	e.preventDefault();
	return hs.expand(this, { wrapperClassName: 'imageContent', slideshowGroup: 99 });
});
// todo not used - remove
/* otevření Highslidu z obrázků */
$('.js_zoomHS').on('click', function (e) {
	e.preventDefault();
	return hs.expand(this, { src: $(this).prop('src'), wrapperClassName: 'imageContent', slideshowGroup: 99 });
});

// todo webaction
$('.js_save-wizard, .js_show-modal').on('click', (e) => {
	e.preventDefault();
	$('.modal__bg').toggleClass('active');
});
// todo webaction
$('.js_close-modal').on('click', (e) => {
	e.preventDefault();
	$('.modal__bg').toggleClass('active');
});

/**
 * zobrazovani <label> jen, pokud je vyplneny prislusny <input>
 */
const showClass = 'show-label';
$(document).on('checkval', '.form-control', function (e) {
	let { value } = this;
	const label = $(this).parents('.form-group').find('.control-label');
	if ($(this).hasClass('fixedPrefixLabel')) {
		value = $(this).find('.fixedPrefix').val();
	}
	if (value !== '') {
		label.addClass(showClass);
	} else {
		label.removeClass(showClass);
	}
}).on('focus keyup change blur', '.form-control', function () {
	$(this).trigger('checkval');
});
// fix pro IE - zobraz <label> po focusu na pole
$(document).on('focus keyup change blur', '.ie .form-control', function (e) {
	const label = $(this).parents('.form-group').find('.control-label');
	let { value } = this;

	if ($(this).parents('.form-group').find('fixedPrefixLabel').length > 0) {
		value = $(this).parents('.form-group').find('.prefix').val();
	}
	if ( (e.type === 'blur' || e.type === 'focusout') && value === '' ) {
		label.removeClass(showClass);
	} else {
		label.addClass(showClass);
	}
});
// Adding similar approach to the select/textarea element
$(document).on('change', 'select', function () {
	const label = $(this).parents('.form-group').find("label");
	label.addClass(showClass);
});

// todo webaction
// custom radio input pro projekt, LV nezachyti zmenu klikem na label
$(document).on('change', '[type=radio]', function (e) {
	$(this).trigger('requestValidation');
});

// zneaktivnění buttonů
let validationPassed;
$(document).on('validationPassed', 'form:has(.js_disabled)', function (e) {
	if ( $(this).find('.form-group.has-error').length === 0 ) {
		// povolit pouze pokud nejsou ve formulari zadne chyby
		$(this).find('.js_disabled').removeClass('disabled');
		$(this).find('.js_bubble').hide();
	}
	validationPassed = true;
}).on('validationFailed', 'form:has(.js_disabled)', function (e) {
	$(this).find('.js_disabled').addClass('disabled');
	$(this).find('.js_bubble').show();
	validationPassed = false;
});

/* pri kliku na bublinu odscroluj na prvni nevyplnene pole */
$(document).on('click', '.js_bubble', function () {
	const $form = $(this).parents('form');
	const $widgets = $form.find('.form-control').filter(function (index){
		return ( $(this).val() === '');
	});
	const $widget = $( $widgets.get(0) );
	if ($widget.length) {
		// pokud existuje prazdny widget, odskoc na nej
		scrollToAnchor( $widget );
		$widget.trigger('focus');
	} else {
		// jinak skoc na zacatek formulare
		scrollToAnchor( $form );
	}
});

/* pri submitu odscroluj na prvni chybove pole, pokud existuje */
$(document).on('validationFailed', '.content-wizard form', (event) => {
	const $firstErrorWidget = $(event.target).find('.has-error');
	if ($firstErrorWidget.length) scrollToAnchor( $firstErrorWidget.get(0) );
});

function getUrlParameter(name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	const regex = new RegExp(`[\\?&]${ name }=([^&#]*)`);
	const results = regex.exec(window.location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

if (getUrlParameter('anchor') && $(`#${ getUrlParameter('anchor') }`).length) {
	scrollToAnchor(`#${ getUrlParameter('anchor') }`);
}

if ($('#weKnow').length) {
	scrollToAnchor($('#weKnow').parent() );
}

// loose focus after typeahead select (prevents double partial updates and validations)
$w.on('typeahead:select', e => $(e.target).blur() );

// z pruvodce Flexi Risk pri kliknuti na logo v zahlavi proved eventu Zmena balicku (link zpet na 2. krok)
const btnChangePack = $('.js_packageChange');
if ( btnChangePack.length ) {
	$(document).on('click', '.logo .link', (e) => {
		e.preventDefault();
		btnChangePack.trigger('click');
		return false;
	});
}

$('.js_inputmask').inputmask();

$(document).affiliate();

$(document).on('change blur', '.js_requestValidation', function (e) {
	const validationTarget = $(this).data('requestValidationTarget') || $(this);
	$(validationTarget).each(function () {
		const $t = $(this);
		if ( $t.val() !== '' ) {
			setTimeout(() => {
				$t.trigger('requestValidation');
			},100);
		}
	});
});

// prenacte stranku po stazeni dokumentu; @see https://ep.vig.cz/issues/9981
$(document).on('click', '.js_table-read a', (e) => {
	setTimeout(() => {
		window.location.reload(true);
	},2500);
});

const iFrameResize = require('iframe-resizer/js/iframeResizer');
const iframes = document.querySelectorAll('iframe');
if ( iframes.length ) {
	const opts = {};
	for (const iframe of iframes) {
		iFrameResize(opts, iframe);
	}
}


/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript const q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
$.each(q, function (index, f) {
	$(f);
});




// WEBPACK FOOTER //
// ./config/fe/web-default/src/js/web.js